exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".project-dashboard {\n  overflow-y: auto;\n}\n.project-dashboard h3 {\n  font-weight: 600;\n}\n.project-dashboard .project-column {\n  overflow-x: scroll;\n}\n", ""]);

